//  仿效一个完整的 ES2015+ 环境 解决兼容问题
import 'babel-polyfill'
import 'amfe-flexible'
// The Vue build platform to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
// import Cube from 'cube-ui'
import App from './App'
import '../theme/index.css'
// import ElementUI from 'element-ui'
import store from './store'
import * as filters from 'common/filter/filter'
import '@/assets/icon/iconfont.css'
import BackEvent from 'common/js/UBackEvent'
// import $ from 'jquery'
import { exitApp, getUser } from 'common/js/mobilePlugin'
// import { getPlatform } from 'common/utils/platform'
import UAccoutService from 'common/js/UAccoutService'
import i18n from './i18n.js'
import router from './router'
import UlearningUI from 'ulearning-ui';
import 'ulearning-ui/lib/styles/index.css';
Vue.use(UlearningUI);
import Navigation from 'vue-navigation'
import UGlobalService from 'common/js/UGlobalService'
import {
  Dialog
} from 'element-ui'
import { Scroll } from 'cube-ui'
import { getPlatform } from './common/utils/platform.js'
import { getCookie } from 'common/js/cookie'
Vue.use(Scroll)
Vue.use(Dialog)

// Vue.use(Cube)
// Vue.use(ElementUI)
Vue.use(Navigation, {router})
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
Vue.config.productionTip = false
router.beforeEach((to, from, next) => {
  if (from.path === '/' && to && to.query && to.query.ub2 && to.query.ub2 === '1' && (!UGlobalService.getGlobal().ub2 || UGlobalService.getGlobal().ub2 !== '1')) {
    UGlobalService.setGlobal({
      'ub2': '1',
      'ocId': to.query.ocId
    })
    console.log(UGlobalService.getGlobal())
  }
  next()
})
router.afterEach(function (to) {
  store.commit('UPDATELOADINGSTATUS', {isLoading: false})
  window.scrollTo(0, 0)
})

function initVue () {
  let root = new Vue({
    el: '#app',
    router,
    store,
    i18n,
    template: '<App/>',
    components: {App},
    mounted () {
      document.addEventListener('backbutton', this.onBackbutton, false)
    },
    methods: {
      onBackbutton () {
        if (BackEvent.isBindBackEvent(router.currentRoute)) {
          BackEvent.handBackEvent(router.currentRoute)
        } else {
          window.history.length > 1 ? router.back() : exitApp()
        }
      }
    }
  })
}


function onDeviceReady () {
  /* eslint-disable no-new */
  console.log('onDeviceReady')
  getUser(function (user) {
    UAccoutService.setAccount(user)
    initVue()
  })

  window.onReloadUserInfo = function () {
    console.log('onReloadUserInfo')
    window.isReLoging = false
    getUser(function (user) {
      UAccoutService.setAccount(user)
    })
  }
  // document.addEventListener('backbutton', onBackKeyDown, false)

  // function onBackKeyDown () {
  //   if (BackEvent.isBindBackEvent(router.currentRoute)) {
  //     BackEvent.handBackEvent(router.currentRoute)
  //   } else {
  //     window.history.length > 1 ? router.back() : exitApp()
  //   }
  // }

  // Android 手机下输入框获取焦点时, 输入法会挡住输入框处理
  if (/Android/gi.test(navigator.userAgent)) {
    window.addEventListener('resize', function () {
      if (document.activeElement.tagName === 'INPUT' || document.activeElement.tagName === 'TEXTAREA') {
        window.setTimeout(function () {
          document.activeElement.scrollIntoViewIfNeeded()
        }, 0)
      }
    })
  }
}

if (getPlatform().isInApp) {
  console.log('pluginReady')
  window.pluginReady = onDeviceReady
} else {
  let user = getCookie('USERINFO')
  if (user) {
    const data = JSON.parse(user)
    UAccoutService.setAccount(data)
  }
  initVue()
}
// document.addEventListener('deviceready', onDeviceReady, false)

// // 添加时间戳 防止缓存
// if (!window.location.search) {
//   window.location.search = '?v=' + new Date().getTime()
// }



// WEBPACK FOOTER //
// ./src/main.js